import React from 'react';
import { Icon } from './Icon.js';
export const IconCirclePencil = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6.00003 20L8.50002 13L15.5 13L18 20", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9.5 13L11.5 7H12.5L14.5 13", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconCirclePencil.js.map